interface ValueBlob {
  type: 'blob';
  body: Blob;
}

interface ValueJson {
  type: 'json';
  body: unknown;
}

interface ValueText {
  type: 'text';
  body: string;
}

type Value = ValueBlob | ValueJson | ValueText

export const None = Symbol('None')
type None = typeof None

export class BodyCache {
  value: Value | null = null

  constructor(public response: Response) { }

  async blob(): Promise<Blob> {
    const blob = await this.response.blob()
    this.value = { type: 'blob', body: blob }
    return blob
  }

  async json(): Promise<unknown> {
    const json = await this.response.json()
    this.value = { type: 'json', body: json }
    return json
  }

  async text(): Promise<string> {
    const text = await this.response.text()
    this.value = { type: 'text', body: text }
    return text
  }

  async tryBlob(): Promise<Blob | None> {
    if (this.value) {
      return this.value.type === 'blob' ? this.value.body : None
    }
    return this.blob()
  }

  async tryJson(): Promise<unknown | None> {
    if (this.value) {
      return this.value.type === 'json' ? this.value.body : None
    }
    return this.json()
  }

  async tryText(): Promise<string | None> {
    if (this.value) {
      return this.value.type === 'text' ? this.value.body : None
    }
    return this.text()
  }
}
